import type { Skill } from '../types'

export const skills: Skill[] = [
  {
    category: 'Front End',
    icon: 'react-atom',
    items: [
      'React 19',
      'TypeScript (strict)',
      'Next.js',
      'React Native',
      'TanStack Query',
      'GraphQL / Apollo',
      'Three.js',
      'Vite',
    ],
  },
  {
    category: 'Back End & APIs',
    icon: 'server-stack',
    items: [
      'Node.js',
      'Express',
      'Python (FastAPI, Django)',
      'Cloud Functions / Cloud Run',
      'PostgreSQL',
      'MySQL',
      'Redis',
      'MongoDB',
    ],
  },
  {
    category: 'Cloud & Platform',
    icon: 'cloud-devops',
    items: [
      'GCP (BigQuery, Firestore)',
      'AWS (ECS, Lambda, S3)',
      'Docker',
      'Kubernetes',
      'Terraform',
      'GitHub Actions',
      'VPC Egress Controls',
      'IAM & Org Policy',
    ],
  },
  {
    category: 'AI & ML',
    icon: 'ai-brain',
    items: [
      'TensorFlow',
      'PyTorch',
      'scikit-learn',
      'OpenAI APIs',
      'Langchain',
      'ML Ops',
      'Data Science',
      'Analytics',
    ],
  },
  {
    category: 'Security & Compliance',
    icon: 'security-shield',
    items: [
      'OAuth2 / OIDC',
      'JWT & ID-token verification',
      'RBAC & zero-trust',
      'Audit-evidence design',
      'Secret Manager / KMS',
      'NERC CIP 004/005/007/011/013',
      'SOC 2 & NIST 800-53',
      'Threat modeling',
    ],
  },
]
